import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';

import {
  provideNgxWebstorage,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage
} from 'ngx-webstorage';

import { AuthenticationService } from './authentication.service';
import { AuthGuardService } from './auth.guard';
import { ErrorService } from 'core/error.service';
import { httpInterceptorProviders } from './interceptors';
import { ApiInfoService } from './api.info.service';
import { SaveChangesGuard } from './save-changes-guard';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import MyPreset from './myPreset';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    AuthenticationService,
    AuthGuardService,
    SaveChangesGuard,
    ErrorService,
    ApiInfoService,
    httpInterceptorProviders,
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'ecom' }),
      withLocalStorage(),
      withSessionStorage()
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || 'none'
        }
      },
      ripple: false
    })
  ]
})
export class CoreModule {}
